"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _phoneValidation = require("../global/utils/phoneValidation");

var _PracticeBannerModule = _interopRequireDefault(require("./PracticeBanner.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules
// Utils
// Styles
var PracticeBanner = function PracticeBanner(props) {
  var imgUrl = props.imgUrl,
      date = props.date,
      name = props.name,
      street = props.street,
      city = props.city,
      state = props.state,
      zip = props.zip,
      phone = props.phone;

  var handleError = function handleError(e) {
    var _e$target;

    console.log("Could not get image from ".concat(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.src, ", removing image from PracticeBanner component"));
    var parent = e.target.parentElement;
    parent.removeChild(e.target);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _PracticeBannerModule.default.container
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: _PracticeBannerModule.default.img,
    src: imgUrl,
    alt: name,
    onError: handleError
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: _PracticeBannerModule.default.date
  }, date), /*#__PURE__*/_react.default.createElement("div", {
    className: _PracticeBannerModule.default.details
  }, /*#__PURE__*/_react.default.createElement("h3", null, name), /*#__PURE__*/_react.default.createElement("p", null, street), /*#__PURE__*/_react.default.createElement("p", null, city, city ? ', ' : '', state, state ? ' ' : '', zip), phone ? /*#__PURE__*/_react.default.createElement("p", null, (0, _phoneValidation.formatPhone)(phone)) : null));
};

var _default = PracticeBanner;
exports.default = _default;